
// Import vendor modules.
import Alpine from "@alpinejs/csp";

// Import application modules.
import { apiClient } from "/client/site/_shared/js/injector.js";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

Alpine.data( "z8a31z_BlogPost", BlogPost );
Alpine.data( "z8a31z_Title", Title );
Alpine.data( "z8a31z_RelatedBlogPosts", RelatedBlogPosts );

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function BlogPost() {

	return {
		init,
		applySyntaxHighlighting,
	};

	// ---
	// LIFE-CYCLE METHODS.
	// ---

	function init() {

		this.applySyntaxHighlighting();

	}

	// ---
	// PRIVATE METHODS.
	// ---

	async function applySyntaxHighlighting() {

		var codeNodes = document.querySelectorAll( "#blog-post pre code" );
		var languageBlocks = [];

		codeNodes.forEach(( node, i ) => {

			var parts = ( node.getAttribute( "class" ) ?? "" ).split( "-" );
			var prefix = parts.shift();

			if ( prefix !== "language" ) {

				return;

			}

			var language = parts.join( "-" );

			if ( ! language ) {

				return;

			}

			var code = node.textContent;

			languageBlocks.push({
				node,
				language,
				code,
			});

		});

		if ( ! languageBlocks.length ) {

			return;

		}

		var blocks = languageBlocks.map(( element ) => {

			return {
				language: element.language,
				code: element.code,
			};

		});

		var payload = JSON.stringify( blocks );
		var startedAt = Date.now();
		var startedVisibility = document.visibilityState;

		try {

			var response = await apiClient.makeRequestWithRetry({
				method: "post",
				url: "/index.cfm?event=api.blog.highlight",
				form: {
					blocks: payload,
				}
			});

		} catch ( error ) {

			// Note: no AbortSignal is used today; but if we add one in the future, this
			// will prevent the aborted request from being logged.
			if ( error.type === "AbortError" ) {

				return;

			}

			// If the tab loaded in the background, there's a good chance it will fail due
			// to the way the browser prioritizes and manages background activity. We
			// don't need to log those failures as they are out of our control.
			if ( startedVisibility === "hidden" ) {

				return;

			}

			console.warn( "Failed to apply syntax highlighting to page." );
			console.error( error );
			window.Bugsnag?.notify( error, ( event ) => {
				event.context = "syntax-highlighting";
				event.addMetadata( "ApiClient", {
					type: error.type,
					domainType: error.domainType,
					status: error.status,
					causeName: error.cause?.name,
					causeMessage: error.cause?.message,
				});
				event.addMetadata( "Diagnostics", {
					attempts: error.attempts,
					elapsedMs: ( Date.now() - startedAt ),
					pageAgeMs: Math.round( performance.now() ),
					startedVisibility: startedVisibility,
					failedVisibility: document.visibilityState,
					onLine: navigator.onLine,
					webdriver: navigator.webdriver,
					effectiveType: navigator.connection?.effectiveType,
					blockCount: blocks.length,
					payloadLength: payload.length,
				});
			});
			return;

		}

		for ( var [ i, html ] of response.results.entries() ) {

			languageBlocks[ i ].node.innerHTML = html;

		}


	}

}

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function Title() {

	return {
		highlight,
	}

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I select the whole title value.
	*/
	function highlight() {

		var range = document.createRange();
		range.selectNode( this.$el );

		var selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange( range );

	}

}

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function RelatedBlogPosts() {

	return {
		expand,
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I expand the list of related blog posts (this removes the ability to collapse since
	* this doesn't need to be a two-way action).
	*/
	function expand() {

		this.$refs.actions.classList.add( "m-related-posts__actions--hidden" );
		this.$refs.list.classList.remove( "m-related-posts__list--truncated" );
		this.$refs.list
			.querySelector( "a" )
			.focus()
		;

	}

}